import { API } from './API.js';
import axios from 'axios';

const url = API + '/niches/';
const debug = false;

class Niches {
    static get() {
        return new Promise ( async (resolve, reject) => {
            try {
                const res = await axios.get(url);
                const data = res.data;
                resolve(
                    data.map(winery=> ({
                        ...winery,
                        name: winery.name
                    }))
                );
                if (debug) console.log("Niches.get: data = ", data)
            } catch(err) {
                reject(err);
            }
        })
    }

    // get one winery
    static getone(id) {
        return axios.get(`${url}${id}`)
            .then(response => {
                if (debug) console.log('Niches.getone: ',response.data)
                return response.data
            })
            .catch(error => {
                console.log('Niches.getone: ',error)
            })
    }

    static create(postdata) {
        if (debug) console.log('Niches.create: postdata = ',postdata)
        return axios.post(url, postdata)
            .then(response => {
                if (debug) console.log('Niches.create: response = ',response)
                return response.data._id
            })
            .catch(error => {
                console.log('Niches.create: ',error)
            })
    }

    static update(id,postdata) {
        if (debug) console.log('Niches.update: id=',id)
        if (debug) console.log('Niches.update: postdata=',postdata)
        return axios.put(`${url}${id}`, postdata)
            .then(response => {
                if (debug) console.log('Niches.update: ',response)
                return id
            })
            .catch(error => {
                console.log('Niches.update: ',error)
            })
    }

    static delete(id) {
        return axios.delete(`${url}${id}`)
    } 
}

export default Niches